import React from 'react';
import './Footer.css';

const Footer = ({ language }) => {
  const translations = {
    en: {
      quickLinks: 'QUICK LINKS',
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact',
      copyright: '© 2025 Movexa Integrated Solutions. All rights reserved.',
    },
    ar: {
      quickLinks: 'روابط سريعة',
      home: 'الرئيسية',
      about: 'حول',
      services: 'الخدمات',
      contact: 'اتصل بنا',
      copyright: '© 2025 Movexa Integrated Solutions. جميع الحقوق محفوظة.',
    },
  };

  const t = translations[language];

  return (
    <footer>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/logo.png" alt="Movexa Logo" />
              <h4>MOVEXA</h4>
            </div>
            <p style={{ fontSize: '0.9rem', opacity: 0.8 }}>
              Integrated Solutions for Smart Logistics
            </p>
          </div>

          <div className="footer-section">
            <h3>{t.quickLinks}</h3>
            <div className="footer-links">
              <a href="#home">{t.home}</a>
              <a href="#about">{t.about}</a>
              <a href="#services">{t.services}</a>
              <a href="#contact">{t.contact}</a>
            </div>
          </div>

        </div>

        <div className="footer-bottom">
          <p>{t.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
